<template>
  <div class="sync-index">
    <div class="row">
      <div class="col-md-6">
        <div v-loading="isRunningAdmin === true">
          <button class="btn btn-fill btn-success btn-wd"
                  @click="startReplication('admin')">
            Iniciar Sincronia do Banco Admin
          </button>
        </div>
      </div>
      <div class="col-md-6">
        <div v-loading="isRunningDocs === true">
          <button class="btn btn-fill btn-success btn-wd"
                  @click="startReplication('docs')">
            Iniciar Sincronia do Banco de Documentos
          </button>
        </div>
      </div>
    </div>
    <br />
    <br />
    <el-table
      v-if="jobs.length > 0"
      class="table-striped"
      :data="jobs"
    >
      <el-table-column
        prop="source"
        label="Banco"
      />
      <el-table-column
          prop="state"
          label="Status"
      >
        <template slot-scope="scope">
          Em andamento
        </template>
      </el-table-column>
      <el-table-column
          prop="start_time"
          label="Iniciado Em"
      >
        <template slot-scope="scope">
          {{ new Date(scope.row.start_time) | moment('DD/MM/YYYY HH:mm:ss') }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import Couchdb from 'src/services/Couchdb'
import swal from 'sweetalert2'
export default {
  name: 'sync-index',
  data () {
    return {
      intervalCheckJob: null,
      isRunningAdmin: false,
      isRunningDocs: false,
      payload: {
        admin: {
          db: 'dev_trg_efce_admin',
          source: '',
          target: '',
          create_target: false,
          continuous: false
        },
        docs: {
          db: 'dev_trg_efce_docs',
          source: '',
          target: '',
          create_target: false,
          continuous: false
        }
      },
      jobs: []
    }
  },
  methods: {
    startReplication (db) {
      if (db === 'admin') {
        this.isRunningAdmin = true
      }
      if (db === 'docs') {
        this.isRunningDocs = true
      }
      Couchdb.getHttpInstance().post('_replicator/', this.payload[db])
      .then((responseCreate) => {
        this.getJobs()
        swal({
          title: 'Sincronia Iniciada.',
          text: 'Você deve manter a conexão com a internet. Porém pode sair desta página ou fechar o navegador',
          type: 'info'
        })
        this.startCheckJobs()
      })
      .catch((errCreate) => console.log(errCreate))
    },
    getJobs () {
      Couchdb.getHttpInstance().get('_scheduler/jobs/')
      .then((response) => {
        this.isRunningAdmin = false
        this.isRunningDocs = false
        this.jobs = response.data.jobs
        if (response.data.total_rows > 0) {
          response.data.jobs.forEach(job => {
            let testAdmin = new RegExp(this.payload.admin.db)
            let testDocs = new RegExp(this.payload.docs.db)
            if (testAdmin.test(job.source)) {
              this.isRunningAdmin = true
            }
            if (testDocs.test(job.source)) {
              this.isRunningDocs = true
            }
            this.checkStateReplication(job.doc_id)
          })
        } else {
          clearInterval(this.intervalCheckJob)
          this.intervalCheckJob = 0
          this.isRunningAdmin = false
          this.isRunningDocs = false
        }
      })
      .catch((err) => console.log(err))
    },
    checkStateReplication (id) {
      Couchdb.getHttpInstance().get('_scheduler/docs/_replicator/' + id)
      .then((response) => {
        if (response.data.state === 'crashing') {
          swal({
            title: 'Falha na Sincronia.',
            text: 'Houve um erro na sincronia.',
            type: 'error'
          })
          this.deleteReplication(id)
        }
      })
      .catch((err) => console.log('errCheckStateReplication', err))
    },
    deleteReplication (id) {
      Couchdb.getHttpInstance().post('_replicator/_find', {
        selector: {
          _id: id
        }
      })
      .then(response => {
        if (response.data.docs.length > 0) {
          let rev = response.data.docs[0]._rev
          this._deleteReplication(id, rev)
        } else {
          clearInterval(this.intervalCheckJob)
          this.intervalCheckJob = 0
        }
      })
      .catch((err) => console.log('errGetRevReplication', err))
    },
    _deleteReplication (id, rev) {
      Couchdb.getHttpInstance()
      .delete('_replicator/' + id, {
        params: {
          'rev': rev
        }
      })
      .then(responseDelete => {
        clearInterval(this.intervalCheckJob)
        this.intervalCheckJob = 0
        this.getJobs()
        // console.log('responseDelete', responseDelete)
      })
      .catch(errDelete => {
        console.log('errDelete', errDelete)
      })
    },
    startCheckJobs () {
      this.intervalCheckJob = setInterval(() => this.getJobs(), 10000)
    }
  },
  computed: {

  },
  created () {
    this.payload.admin.source = process.env.DB_HOST.replace('http://', 'http://' + process.env.DB_USER + ':' + process.env.DB_PASS + '@') + '/' + process.env.DB_NAME
    this.payload.admin.target = process.env.DB_SYNC_ADMIN_HOST.replace('http://', 'http://' + process.env.DB_SYNC_ADMIN_USER + ':' + process.env.DB_SYNC_ADMIN_PASS + '@') + '/' + process.env.DB_SYNC_ADMIN_NAME
    this.payload.docs.source = process.env.DB_DOCS_HOST.replace('http://', 'http://' + process.env.DB_DOCS_USER + ':' + process.env.DB_DOCS_PASS + '@') + '/' + process.env.DB_DOCS_NAME
    this.payload.docs.target = process.env.DB_SYNC_DOCS_HOST.replace('http://', 'http://' + process.env.DB_SYNC_DOCS_USER + ':' + process.env.DB_SYNC_DOCS_PASS + '@') + '/' + process.env.DB_SYNC_DOCS_NAME
    this.getJobs()
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Sync/SyncIndex.vue